import { render, staticRenderFns } from "./OfficesDeliveryAllocationsCreate.vue?vue&type=template&id=2183e9b2&scoped=true&"
import script from "./OfficesDeliveryAllocationsCreate.vue?vue&type=script&lang=js&"
export * from "./OfficesDeliveryAllocationsCreate.vue?vue&type=script&lang=js&"
import style0 from "./OfficesDeliveryAllocationsCreate.vue?vue&type=style&index=0&id=2183e9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2183e9b2",
  null
  
)

export default component.exports